export default __webpack_public_path__ + "static/media/termo-sigilo-inss.06ceca3f.doc";